import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  container: {
    display: 'flex',
    gap: '2em',
    marginTop: '3em',
    justifyContent: 'flex-end',
    width: '100%'
  } satisfies SxProps<Theme>
}
